import { css } from '@emotion/react'
import { serverError } from '../../assets/images'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

export type ServerErrorProps = {
  isError: boolean
}

function ServerError({ isError }: ServerErrorProps) {
  // useEffect(() => {
  //   // /error_wrap
  //   document.getElementsByClassName('list_wrap')[0].classList.add('error_wrap')
  //   document.getElementsByClassName('list_wrap')[0].classList.remove('list_wrap')
  // }, [])

  return (
    <div className="wrap error_wrap" style={isError ? { display: 'block' } : { display: 'none' }}>
      <Header classNameString="header" />
      <div className="container">
        <div className="error_box">
          <div className="img-error type-server"></div>
          <div className="error-txtbtn">
            <p className="txt">
              서버 통신에 실패했어
              <br />
              잠시 후에 다시 해줄래?
            </p>
            <button
              className="btn-error"
              onClick={() => {
                if (isError) return
                window.location.reload()
              }}
            >
              다시 시도
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

// const wrapper = css`
//   background: url(${serverError}) center center no-repeat;
//   background-size: cover;
// `

export default ServerError
